// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__7yKKs","inputWrap":"CustomTip_inputWrap__Mm4IC"};